export default "__VITE_ASSET__BMHNQn_I__"